import React, { useState } from "react";
import "./Card.css";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import Votes from "../Votes";
import TitleSection from "../TitleSection";
import Image from "../Image";
import Video from "../Video";
import Comments from "../Comments";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
import PostModal from "../PostModal";

export default function Card({ post }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const {
    score,
    author,
    num_comments,
    title,
    is_video,
    is_gallery,
    media_metadata,
    permalink,
    subreddit_name_prefixed: subreddit,
    created,
    url,
  } = post.data;

  let videoSrc;
  if (is_video) {
    videoSrc = post.data.media.reddit_video.fallback_url;
  }

  const gallerySources = [];
  let galleryImages;

  if (is_gallery) {
    galleryImages = Object.values(media_metadata)
      .map((item) => item.p)
      .map((item) => {
        const x = item[item.length - 1].u;
        const y = x.replace(/&amp;/g, "&");
        return y;
      });
    galleryImages.map((item) => {
      return gallerySources.push(<img src={item} alt="" />);
    });
  }

  const image = post.data.post_hint === "image";

  return (
    <>
      {/* <PostModal
        title={title}
        show={show}
        image={image}
        url={url}
        handleClose={handleClose}
        is_video={is_video}
        videoSrc={videoSrc}
        is_gallery={is_gallery}
        gallerySources={gallerySources}
      /> */}
      {console.log(post)}
      <PostModal show={show} handleClose={handleClose} url={url} />
      <div className="card">
        <div className="row g-0">
          <Votes score={score} />

          <div className="col-11">
            <div className="card-body">
              <TitleSection
                subreddit={subreddit}
                author={author}
                created={created}
                title={title}
                handleShow={handleShow}
              />

              {image && <Image url={url} />}
              {is_video && <Video videoSrc={videoSrc} />}
              {is_gallery && (
                <div className="xxx">
                  <AliceCarousel
                    items={gallerySources}
                    fadeOutAnimation={true}
                    mouseTrackingEnabled={true}
                    disableAutoPlayOnAction={true}
                  />
                </div>
              )}

              <Comments num_comments={num_comments} permalink={permalink} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
